import _ from 'lodash';
const sortMap = {
    ORIGINAL: 'famdesc',
    INPADOC: 'ifamdesc',
    EXTEND: 'efamdesc',
    APNO: 'apdesc',
};
export const collapseMap = {
    APNO_FACET: 'APNO',
    FAMILY_ID: 'ORIGINAL',
    INPADOC_FAMILY_ID: 'INPADOC',
    EXTEND_FAMILY: 'EXTEND',
};
export const FST_Map = {
    APNO: 'apno',
    ORIGINAL: 'simple',
    INPADOC: 'inpadoc',
    EXTEND: 'extend',
};
export const FIELD_COLLAPSE_MAP = {
    APN: 'APNO_FACET',
    EXTEND_FAMILY_ID: 'EXTEND_FAMILY',
};
export default {
    sortMap,
    sort2Mode(sort) {
        return _.get(_.invert(sortMap), sort, '');
    },
    getFamilyId(familyTag) {
        if (familyTag) {
            return collapseMap[familyTag] || '';
        }
    },
    getMode(familyTag) {
        if (familyTag) {
            return FST_Map[familyTag] || '';
        }
    },
    getCollapseByField(field) {
        return FIELD_COLLAPSE_MAP[field] || field;
    },
};
